import { Component, HostBinding } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { BeeFreeService } from '../app/services/beefree.service';

declare let gtag;

@Component({
	selector: 'body',
	template: `
		<div class="wrapper">
			<app-top-menu></app-top-menu>
			<router-outlet></router-outlet>
			<app-overlay></app-overlay>
		</div>
	`,
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	@HostBinding('class') public cssClass: string;
	pathList = [
		{ name: 'Components', path: 'components' },
		{ name: 'Component List', path: 'component-list' },
		{ name: 'File Manager', path: 'file-manager' },
		{ name: 'Admin', path: 'admin' },
		{ name: 'Component Report', path: 'component-report' },
		{ name: 'Login', path: 'login' }
	];

	constructor(router: Router, private beeFree: BeeFreeService) {
		this.cssClass = `${environment.name} layout-top-nav`;
		const url = new URL(window.location.href);
		const beeFreeApp = url.searchParams.get('beefree');

		if (beeFreeApp && (beeFreeApp.toLowerCase() === 'html' || beeFreeApp.toLowerCase() === 'image')) {
			this.beeFree.setBeeFreeAddon(beeFreeApp);
			this.sendBeeFreeLoadedMessage();
		}

		const navEndEvents = router.events.pipe(filter((event) => event instanceof NavigationEnd));
		navEndEvents.subscribe((event: NavigationEnd) => {
			gtag('config', environment.GAtag, {
				// page_path: event.urlAfterRedirects,
				// page_title: this.createPageTitle(event.urlAfterRedirects),
				send_page_view: false,
				cookie_flags: 'samesite=none;secure'
			});
			if (event.urlAfterRedirects.split('/')[1] !== 'component') {
				gtag('event', 'page_view', {
					page_path: event.urlAfterRedirects,
					page_title: this.createPageTitle(event.urlAfterRedirects)
				});
			}
		});
	}

	sendBeeFreeLoadedMessage() {
		const messageData = {
			isRounded: false,
			hasTitleBar: false,
			showTitle: false,
			width: '1200px',
			height: '690px'
		};
		this.beeFree.sendMessage(messageData, 'loaded');
	}

	createPageTitle(path) {
		if (path === '/' || (path.includes('?') && path.split('?')[0] === '/')) {
			return this.createTitleText({ name: this.pathList[0].name });
		} else {
			const selectedPath = this.pathList.filter((item) => path.includes(item.path));
			if (selectedPath.length) {
				const params = {
					name: selectedPath[0].name,
					widgetID: selectedPath[0].path === 'component-report' ? path.split('/').pop() : null
				};
				return this.createTitleText(params);
			} else {
				return this.createTitleText({ name: path });
			}
		}
	}

	createTitleText(params) {
		const befreeAddonText = this.beeFree.isBeeFreeAddon() ? ' - Beefree Addon' : '';
		const widgetIDText = params.widgetID ? ` - Widget ID: ${parseInt(params.widgetID)}` : '';
		return `DynamicMail Creator - ${params.name}${widgetIDText}${befreeAddonText}`;
	}
}
